// import path from 'path'

export const DEFAULT_FIXED_WIDTH = 400
export const DEFAULT_FLUID_MAX_WIDTH = 800
export const STORYBLOK_BASE_URL = 'https://a.storyblok.com'

export const breakpoints = [375, 480, 768, 1024, 1200, 1440, 1920]
export const defaultOptions = {
  // quality: 70,
  smartCrop: true,
  format: null,
  fill: null,
  toFormat: null,
  base64: null,
  useBase64: true
}

export const defaultFluidOptions = {
  ...defaultOptions,
  maxWidth: DEFAULT_FLUID_MAX_WIDTH,
  maxHeight: null
}

export const defaultFixedOptions = {
  ...defaultOptions,
  width: DEFAULT_FIXED_WIDTH,
  height: null
}
